import { StyleSheet, Text, View } from "@react-pdf/renderer"
import { Row } from "@tanstack/react-table"
import { FC, Fragment } from "react"

const styles = StyleSheet.create({
  row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    borderBottomColor: "rgba(239, 239, 239, 1)",
    borderBottomWidth: 1
  },

  column: {
    flex: 1,
    paddingTop: "4px",
    textAlign: "left",
    paddingLeft: 8,
    paddingRight: 8
  }
})

interface TableRowProps {
  data: Row<any>[]
}

const TableRow: FC<TableRowProps> = ({ data }) => {
  const rows = data?.map((row: Row<any>, index: number) => {
    return (
      <View style={styles.row} key={index}>
        {row
          .getVisibleCells()
          .filter((x) => !x.column.columnDef.meta?.hiddenFilter as boolean)
          .map((cell) => (
            <Text style={styles.column} key={cell.id}>
              {cell.getValue()}
            </Text>
          ))}
      </View>
    )
  })

  return <Fragment>{rows}</Fragment>
}

export default TableRow
